module.exports = __webpack_public_path__ + "media/fonts/ProximaNova-Semibold-88bf3664.eot";